module.exports = __webpack_public_path__ + "img/cyyc4.17f87a92.jpg";